var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3183 16.9998V19.33H9.09544V16.9998C7.69581 16.858 6.40131 16.2349 5.46075 15.2501C4.52019 14.2654 3.99994 12.9885 4 11.665V10.132H5.22291V11.665C5.22291 12.7831 5.69532 13.8554 6.53624 14.646C7.37715 15.4366 8.51767 15.8807 9.70689 15.8807C10.8961 15.8807 12.0366 15.4366 12.8776 14.646C13.7185 13.8554 14.1909 12.7831 14.1909 11.665V10.132H15.4138V11.665C15.4138 12.9885 14.8936 14.2654 13.953 15.2501C13.0125 16.2349 11.718 16.858 10.3183 16.9998ZM6.44581 7.066C6.44581 6.25285 6.78939 5.473 7.40096 4.89801C8.01253 4.32302 8.842 4 9.70689 4C10.5718 4 11.4013 4.32302 12.0128 4.89801C12.6244 5.473 12.968 6.25285 12.968 7.066V11.665C12.968 12.4782 12.6244 13.258 12.0128 13.833C11.4013 14.408 10.5718 14.731 9.70689 14.731C8.842 14.731 8.01253 14.408 7.40096 13.833C6.78939 13.258 6.44581 12.4782 6.44581 11.665V7.066Z",
    fill: "#F04E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedMic);
export default __webpack_public_path__ + "static/media/red-mic.2c033bc6181c99aa8b34f11415ecfb7a.svg";
export { ForwardRef as ReactComponent };